import React from 'react';
import './MarketingConsentDialog.css';
import { useTranslation } from 'react-i18next';

interface MarketingConsentDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const MarketingConsentDialog: React.FC<MarketingConsentDialogProps> = ({
    isOpen,
    onClose,
    onConfirm
}) => {
    const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="marketing-consent-dialog">
            <div className="marketing-consent-dialog__overlay" onClick={onClose} />
            <div className="marketing-consent-dialog__content">
                <h2 className="marketing-consent-dialog__title">{t('marketingConsentDialog.title')}</h2>
                <p className="marketing-consent-dialog__description">
                    {t('marketingConsentDialog.description')}
                </p>
                <p className="marketing-consent-dialog__what">
                    {t('marketingConsentDialog.question')}
                </p>
                <div className="marketing-consent-dialog__buttons">
                    <button
                        className="marketing-consent-dialog__button marketing-consent-dialog__button--confirm"
                        onClick={onConfirm}
                    >
                        {t('marketingConsentDialog.confirmButton')}
                    </button>
                    <button
                        className="marketing-consent-dialog__button marketing-consent-dialog__button--skip"
                        onClick={onClose}
                    >
                        {t('marketingConsentDialog.skipButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MarketingConsentDialog;
